import {
  Component,
  inject,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Router } from '@angular/router';
import { NavService } from '@app/core/services/nav.service';
import { INavigationType } from '../../interfaces/navigation.interface';
import { Bind } from 'primeng/bind';
import { Button } from 'primeng/button';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { HasPermissionDirective } from '../../../../core/directives/has-permission.directive';
import { NgTemplateOutlet } from '@angular/common';
import { NavigationItemComponent } from '../navigation-item/navigation-item.component';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    Bind,
    Button,
    AngularSvgIconModule,
    HasPermissionDirective,
    NgTemplateOutlet,
    NavigationItemComponent,
  ],
})
export class SettingsComponent {
  // dependencies
  navService = inject(NavService);
  private _router = inject(Router);

  navigationConfig = signal<INavigationType[]>(
    this.navService.getSettingsNavigation(),
  );

  constructor() {}

  onBack(): void {
    this.navService.closeSettings();
    this.navService.closeMobileMenu();

    const lastRoute: string = this.navService.lastMainRoute();
    if (lastRoute) {
      this._router.navigate([lastRoute]);
    } else {
      this._router.navigate(['/account/dashboard']);
    }
  }
}
